@if (!isNew) {
	<app-record-header
		[recordData]="recordData()"
		[moduleName]="'customers|title'"
		[module]="module"
		[headerData]="headerData"
		[isNew]="isNew"
		[isSaving]="isSaving"
		[isEditMode]="isEditMode"
		(onEdit)="onEditClicked()"
		(onSave)="onSaveClicked()"
		(onCancel)="onCancelClicked()"
		(onTitleClick)="onTitleClicked()"
		[isSaveButtonActive]="isSaveButtonActive"
		[isStacked]="isStacked()"
		[savedWhileEditing]="savedWhileEditing()">
		<div class="record-menu">
			<app-customers-list-item-menu
				#recordListMenu
				[isEditMode]="isEditMode"
				[item]="recordData()" /></div
	></app-record-header>
}
<ion-content [scrollY]="false" [scrollX]="false">
	<ion-nav #nav />
</ion-content>

<ng-template #tabsBody>
	@if (!isNew) {
		<app-record-tabs
			pane-body
			[selectedTab]="recordTab"
			[moduleEnum]="this.module"
			[id]="this.recordData().id"
			[isNew]="isNew"
			[recordTabs]="recordTabs"
			(viewDetails)="showMoreSections()">
			<ng-template [tabContent]="recordTabs.overview.value">
				<ng-container [ngTemplateOutlet]="overview"></ng-container>
			</ng-template>

			<ng-template [tabContent]="recordTabs.links.value">
				<app-module-selector
					[nav]="nav"
					[isNew]="isNew"
					[recordId]="recordData().id" />
			</ng-template>
			<ng-template [tabContent]="recordTabs.activity.value">
				<app-no-activity />
			</ng-template>
		</app-record-tabs>
	}
</ng-template>

<ng-template #overview>
	<app-customers-summary
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		[recordData]="recordData()"
		(sectionChanged)="sectionDataChangedHandler($event)" />
	<app-contact-card [recordData]="recordData()" />

	@if (recordData().type === customerType.INDIVIDUAL) {
		<app-driver-overview-card [recordData]="recordData()" />
	}

	@if (recordData().notes) {
		<app-comments-card [recordData]="recordData()" />
	}

	<app-annotations-section
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="true"
		(sectionChanged)="
			sectionDataChangedHandler($event); isNew ? null : saveSection()
		" />
</ng-template>

<ng-template #moreSections>
	@if (!isNew) {
		<app-more-details
			[nav]="nav"
			[isNew]="isNew"
			[footer]="recordFooter"
			[projectedSections]="recordSections()"
			[errors]="errorMessages | async"
			(onBack)="navToTabs()">
		</app-more-details>
	} @else {
		<app-stepper
			[isStacked]="isStacked()"
			[newSaveButton]="newSaveButton"
			[errors]="errorMessages | async"
			[title]="'customers|add-title'"
			[overview]="overview"
			[projectedSections]="recordSections()" />
	}
</ng-template>

<ng-template #newSaveButton>
	<button
		[disabled]="!isSaveButtonActive || isSaving"
		(click)="onSaveClicked()"
		color="primary"
		type="button"
		ultra-primary
		svgIcon="check"></button>
</ng-template>

<ng-template #recordFooter>
	<app-context-info [numberOfErrors]="(errorMessages | async)?.length">
		<ng-content select=".context-info-extras"></ng-content>
		<app-errors-box [errorMessages]="errorMessages | async" />
	</app-context-info>

	<ion-fab slot="fixed">
		<app-record-footer
			[isSaving]="isSaving"
			[isEditMode]="isEditMode"
			[isDeleted]="false"
			[isSaveButtonActive]="isSaveButtonActive"
			(onEdit)="onEditClicked()"
			(onSave)="onSaveClicked()"
			(onCancel)="onCancelClicked()" />
	</ion-fab>
</ng-template>

<!-- Sections -->
@if (!originModule() && isNew) {
	<ng-template
		[appSectionMetadata]="{
			title: 'shared|class-title',
		}">
		<app-type-section
			[isEditMode]="isEditMode"
			[isNew]="isNew"
			[recordData]="recordData()"
			[options]="typeOptions"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
}

@if (recordData().type === customerType.INDIVIDUAL) {
	<ng-template
		[appSectionMetadata]="{
			title: 'customers|record|contact-individual-section|title',
		}">
		<ng-container [ngTemplateOutlet]="contactIndividual"></ng-container>
	</ng-template>
}

@if (recordData().type === customerType.COMPANY) {
	<ng-template
		[appSectionMetadata]="{
			title: 'customers|record|contact-company-section|title',
		}">
		<ng-container [ngTemplateOutlet]="contactCompany"></ng-container>
	</ng-template>
}

@if (recordData().type === customerType.INDIVIDUAL) {
	<ng-template
		[appSectionMetadata]="{
			title: 'customers|record|driver-section|title',
		}">
		<app-customers-driver
			[isNew]="isNew"
			[isEditMode]="isEditMode"
			[recordData]="recordData()"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
}

<ng-template #contactIndividual>
	<app-customers-contact-individual
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		[recordData]="recordData()"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<ng-template #contactCompany>
	<app-customers-contact-company
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		[recordData]="recordData()"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<ng-template
	[appSectionMetadata]="{
		title: 'shared|comments|title',
	}">
	<app-comments-section
		[isNew]="isNew"
		[recordData]="recordData()"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>
<!--
@if (isNew) {
	<ng-template
		[appSectionMetadata]="{
			title: 'shared|annotations',
		}">
		<app-annotations-section
			[isNew]="isNew"
			[recordData]="recordData()"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
} -->
